import React, { Component } from 'react'
import ContextMenu from './ContextMenu'

export default class ContextMenuComponent extends Component {
    constructor(props) {
        super(props);

        this.state={
            showContext:false,
            top:"0px",
            left:"0px"
        }
        this.showMenu = this.showMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount(){
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        if (this.state.showContext){
            this.setState({top:this.props.targett.getBoundingClientRect().bottom+"px",left:this.props.targett.getBoundingClientRect().left+"px"});
            //his.targett.getBoundingClientRect().bottom+"px",this.targett.getBoundingClientRect().left+"px"
        }
    }

    showMenu(top,left){
        this.setState({top:top,left:left});
        this.setState({showContext:true});
    }

    hideMenu(){
        this.setState({showContext:false});
    }

    menuClicked(title){
        // alert(title);
        this.props.menuClicked(title);
    }

    render() {
        if (!this.state.showContext){
            return null; 
        }
        return (
            <ContextMenu style={{zIndex:'10000'}} dataa={this.props.data} isChart={this.props.isChart} show={this.state.showContext} hideMenu={this.hideMenu.bind(this)} menuClicked={this.menuClicked.bind(this)} topp={this.state.top} leftt={this.state.left} />
        )
    }
}
